import styled from 'styled-components';
import { Capacitor } from '@capacitor/core';

const LogoutButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  width: 56px;
  height: 100%;

  border: none;
  background: none;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    display: block;
  }
`;

const NavigationButton = styled(LogoutButton)`
  left: 0;

  img {
    width: 100%;
  }
`;

export const Styled = {
  NavigationButton,
  LogoutButton,
};
